import { BranchOffice, HeadOffice } from "../components/ContactUs/OfficeAddress";

export const OFFICES_LENGTH = 6;
// keep home page value at last index
export const navColors = [
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/country/' },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/contact-us/' },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/coaching/' },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/aboutus' },
  { navColor: '#226CF5', navMenuColor: '#ffffff', pathName: '/contact-us' },
  {
    navColor: '#FBBFB6',
    navMenuColor: '#0E1B2C',
    pathName: '/student-services/steps-to-study-abroad',
  },
  {
    navColor: '#B8AAEE',
    navMenuColor: '#0E1B2C',
    pathName: '/partners/institutions-universities',
  },
  {
    navColor: '#6C48F0',
    navMenuColor: '#ffffff',
    pathName: '/study-destinations',
  },
  {
    navColor: '#96BCFF',
    navMenuColor: '#0E1B2C',
    pathName: '/entrepreneur/franchise-proposal',
  },
  {
    navColor: '#226CF5',
    navMenuColor: '#ffffff',
    pathName: '/partners/study-abroad-association',
  },
  
  {
    navColor: '#6C48F0',
    navMenuColor: '#ffffff',
    pathName: '/partners/',
  },
  {
    navColor: '#0046c9',
    navMenuColor: '#ffffff',
    pathName: '/online-counselling/',
  },
  {
    navColor: '#0046c9',
    navMenuColor: '#ffffff',
    pathName: '/online-counselling',
  },
  {
    navColor: '#6C48F0',
    navMenuColor: '#ffffff',
    pathName: '/test-preparation',
  },
  { navColor: '#313145', navMenuColor: '#ffffff', pathName: '/universities' },
  { navColor: '#20115b', navMenuColor: '#ffffff', pathName: '/events' },
  {
    navColor: '#6C48F0',
    navMenuColor: '#ffffff',
    pathName: '/student-services/education-loan-for-overseas-education',
  },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/internships' },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/blogs' },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/news' },
  { navColor: '#1e1553e3', navMenuColor: '#ffffff', pathName: '/careers' },
  {
    navColor: '#6C48F0',
    navMenuColor: '#ffffff',
    pathName: '/student-services/study-abroad-scholarships/',
  },
  {
    navColor: '#226cf5',
    navMenuColor: '#ffffff',
    pathName: '/student-services/study-abroad-scholarships',
  },
  {
    navColor: '#313145',
    navMenuColor: '#ffffff',
    pathName: '/partners/webinar-by-university-delegates',
  },
  {
    navColor: '#313145',
    navMenuColor: '#ffffff',
    pathName: '/partners/webinar-by-kc-admission-experts',
  },
  {
    navColor: '#6C48F0',
    navMenuColor: '#ffffff',
    pathName: '/student-services/study-abroad-scholarships',
  },
  {
    navColor: '#226CF5',
    navMenuColor: '#ffffff',
    pathName: '/terms-and-condition',
  },
  { navColor: '#226CF5', navMenuColor: '#ffffff', pathName: '/privacy-policy' },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/corporate-social-responsibility' },
  { navColor: '#6C48F0', navMenuColor: '#ffffff', pathName: '/kc-overseas-mihan-nagpur' },
  {
    navColor: '#6C48F0',
    navMenuColor: '#ffffff',
    pathName: '/allied-services',
  },
  {
    navColor: '#226CF5',
    navMenuColor: '#ffffff',
    pathName: '/payment-and-refund-policy',
  },
  { navColor: '#226CF5', navMenuColor: '#ffffff', pathName: '/' },
];

export const courseCategories = [
  {
    label: 'Business Administration & Management',
    value: 'business_administration_management',
  },
  { label: 'Health Care + Pharma', value: 'healthcare_pharma' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Data Science + Analytics', value: 'data_science_analytics' },
  { label: 'Accounts & Finance', value: 'accounts_finance' },
  { label: 'AI + Robotics', value: 'ai_robotics' },
  { label: 'Computer Science & IT', value: 'computer_science_it' },
  { label: 'Others', value: 'others' },
];

export const coachingCategories = [
  { label: 'IELTS', value: 'IELTS' },
  { label: 'TOEFL', value: 'TOEFL' },
  { label: 'PTE', value: 'PTE' },
  { label: 'GRE', value: 'GRE' },
  { label: 'GMAT', value: 'GMAT' },
  { label: 'SAT', value: 'SAT' },
  { label: 'PSAT', value: 'PSAT' },
  { label: 'Duolingo', value: 'Duolingo' },
  { label: 'ACT', value: 'ACT' },
  { label: 'German Language', value:'Germanlanguage'},
  { label: 'French Language', value:'Frenchlanguage'},
  { label: 'Japanese Language', value:'Japaneselanguage'}
];

export const successStoriesCategories = [
  { label: 'Student', value: 'student' },
  { label: 'Parent', value: 'parent' },
  { label: 'University', value: 'university' },
  { label: 'Franchisee', value: 'franchisee' },
  { label: 'Partner Associate', value: 'partner_associate' },
  { label: 'Employee', value: 'employee' },
];

export const eventTypes = [
  { label: 'Virtual Admissions Day', value: 'virtual_admissions_day' },
  { label: 'Virtual Admissions Week', value: 'virtual_admissions_week' },
  { label: 'Admissions Day', value: 'admissions_day' },
  { label: 'Virtual Edu Expo', value: 'virtual_edu_expo' },
  { label: 'Overseas Education Fair', value: 'overseas_education_fair' },
  { label: 'Applications Week', value: 'applications_week' },
  { label: 'Institutions', value: 'institutions' },
  { label: 'Allied Services', value: 'allied_services' },
  { label: 'Coaching', value: 'coaching' },
  { label: 'Loan Fair', value: 'loan_fair' },
  {label: 'Webinar', value: 'webinar'}
];

export const countries = [
  { slug: 'usa', label: 'USA', value: 'USA' },
  { slug: 'uk', label: 'United Kingdom', value: 'UnitedKingdom' },
  { slug: 'canada', label: 'Canada', value: 'Canada' },
  { slug: 'ireland', label: 'Ireland', value: 'Ireland' },
  { slug: 'australia', label: 'Australia', value: 'Australia' },
  { slug: 'new-zealand', label: 'New Zealand', value: 'NewZealand' },
  { slug: 'germany', label: 'Germany', value: 'Germany' },
  { slug: 'sweden', label: 'Sweden', value: 'Sweden' },
  { slug: 'netherlands', label: 'Netherlands', value: 'Netherlands' },
  { slug: 'france', label: 'France', value: 'France' },
  { slug: 'finland', label: 'Finland', value: 'Finland' },
  { slug: 'dubai', label: 'Dubai', value: 'Dubai' },
  { slug: 'singapore', label: 'Singapore', value: 'Singapore' },
  { slug: 'malta', label: 'Malta', value: 'Malta' },
  { slug: 'hungary', label: 'Hungary', value: 'Hungary' },
  { slug: 'spain', label: 'Spain', value: 'Spain' },
  { slug: 'poland', label: 'Poland', value: 'Poland' },
  { slug: 'malaysia', label: 'Malaysia', value: 'Malaysia' },
  { slug: 'denmark', label: 'Denmark', value: 'Denmark' },
  { slug: 'italy', label: 'Italy', value: 'Italy' },
  { slug: 'switzerland', label: 'Switzerland', value: 'Switzerland' },
  { slug: 'lithuania', label: 'Lithuania', value: 'Lithuania' },
  { slug: 'cyprus', label: 'Cyprus', value: 'Cyprus' },
  { slug: 'china', label: 'China', value: 'China' },
  { slug: 'vietnam', label: 'Vietnam', value: 'Vietnam' },
  { slug: 'japan', label: 'Japan', value: 'Japan' },
  { slug: 'mauritius', label: 'Mauritius', value: 'Mauritius' },
  { slug: 'austria', label: 'Austria', value: 'Austria' },
  { slug: 'belgium', label: 'Belgium', value: 'Belgium' },
  { slug: 'russia', label: 'Russia', value: 'Russia' },
  { slug: 'south-korea', label: 'South Korea', value: 'SouthKorea' },
  { slug: 'india', label: 'India', value: 'India' },
  { slug: 'georgia', label: 'Georgia', value: 'Georgia' },
  { slug: 'monaco', label: 'Monaco', value: 'Monaco' },
  { slug: 'croatia', label: 'Croatia', value: 'Croatia' },
  { slug: 'indonesia', label: 'Indonesia', value: 'Indonesia' },
  { slug: 'sri-lanka', label: 'Sri Lanka', value: 'SriLanka' },
  { slug: 'saudi-arabia', label: 'Saudi Arabia', value: 'SaudiArabia' },
  { slug: 'ajman', label: 'Ajman', value: 'Ajman' },
  { slug: 'kazakhstan', label: 'Kazakhstan', value: 'Kazakhstan' },
  { slug: 'thailand', label: 'Thailand', value: 'Thailand' },
  { slug: 'greece', label: 'Greece', value: 'Greece' },
  { slug: 'umm-al-quwain', label: 'Umm Al Quwain', value: 'UmmAlQuwain' },
  { slug: 'luxembourg', label: 'Luxembourg', value: 'Luxembourg' },
  { slug: 'latvia', label: 'Latvia', value: 'Latvia' }
];

export const unicountries = [
  { countrySlug: 'usa', label: 'USA', value: 'USA' },
  { countrySlug: 'uk', label: 'UK', value: 'UnitedKingdom' },
  { countrySlug: 'canada', label: 'Canada', value: 'Canada' },
  { countrySlug: 'ireland', label: 'Ireland', value: 'Ireland' },
  { countrySlug: 'australia', label: 'Australia', value: 'Australia' },
  { countrySlug: 'new-zealand', label: 'New Zealand', value: 'NewZealand' },
  { countrySlug: 'germany', label: 'Germany', value: 'Germany' },
  { countrySlug: 'sweden', label: 'Sweden', value: 'Sweden' },
  { countrySlug: 'netherlands', label: 'Netherlands', value: 'Netherlands' },
  { countrySlug: 'france', label: 'France', value: 'France' },
  { countrySlug: 'finland', label: 'Finland', value: 'Finland' },
  { countrySlug: 'dubai', label: 'Dubai', value: 'Dubai' },
  { countrySlug: 'singapore', label: 'Singapore', value: 'Singapore' },
  { countrySlug: 'malta', label: 'Malta', value: 'Malta' },
  { countrySlug: 'hungary', label: 'Hungary', value: 'Hungary' },
  { countrySlug: 'spain', label: 'Spain', value: 'Spain' },
  { countrySlug: 'poland', label: 'Poland', value: 'Poland' },
  { countrySlug: 'malaysia', label: 'Malaysia', value: 'Malaysia' },
  { countrySlug: 'denmark', label: 'Denmark', value: 'Denmark' },
  { countrySlug: 'italy', label: 'Italy', value: 'Italy' },
  { countrySlug: 'switzerland', label: 'Switzerland', value: 'Switzerland' },
  { countrySlug: 'lithuania', label: 'Lithuania', value: 'Lithuania' },
  { countrySlug: 'cyprus', label: 'Cyprus', value: 'Cyprus' },
  { countrySlug: 'china', label: 'China', value: 'China' },
  { countrySlug: 'vietnam', label: 'Vietnam', value: 'Vietnam' },
  { countrySlug: 'japan', label: 'Japan', value: 'Japan' },
  { countrySlug: 'mauritius', label: 'Mauritius', value: 'Mauritius' },
  { countrySlug: 'austria', label: 'Austria', value: 'Austria' },
  { countrySlug: 'belgium', label: 'Belgium', value: 'Belgium' },
  { countrySlug: 'russia', label: 'Russia', value: 'Russia' },
  { countrySlug: 'south-korea', label: 'South Korea', value: 'SouthKorea' },
  { countrySlug: 'india', label: 'India', value: 'India' },
  { countrySlug: 'georgia', label: 'Georgia', value: 'Georgia' },
  { countrySlug: 'monaco', label: 'Monaco', value: 'Monaco' },
  { countrySlug: 'croatia', label: 'Croatia', value: 'Croatia' },
  { countrySlug: 'indonesia', label: 'Indonesia', value: 'Indonesia' },
  { countrySlug: 'sri-lanka', label: 'Sri Lanka', value: 'SriLanka' },
  { countrySlug: 'abu-dhabi', label: 'Abu Dhabi', value: 'AbuDhabi' },
  { countrySlug: 'sharjah', label: 'Sharjah', value: 'Sharjah' },
  { countrySlug: 'ras-al-khaimah', label: 'Ras Al Khaimah', value: 'RasAlKhaimah' },
  { countrySlug: 'saudi-arabia', label: 'Saudi Arabia', value: 'SaudiArabia' },
  { countrySlug: 'ajman', label: 'Ajman', value: 'Ajman' },
  { countrySlug: 'kazakhstan', label: 'Kazakhstan', value: 'Kazakhstan' },
  { countrySlug: 'thailand', label: 'Thailand', value: 'Thailand' },
  { countrySlug: 'greece', label: 'Greece', value: 'Greece' },
  { countrySlug: 'umm-al-quwain', label: 'Umm Al Quwain', value: 'UmmAlQuwain' },
  { countrySlug: 'luxembourg', label: 'Luxembourg', value: 'Luxembourg' },
  { countrySlug: 'latvia', label: 'Latvia', value: 'Latvia' },
  { countrySlug: 'turkey', label: 'Turkey', value: 'Turkey' },
  { countrySlug: 'bahrain', label: 'Bahrain', value: 'Bahrain' },
  { countrySlug: 'slovenia', label: 'Slovenia', value: 'Slovenia' },
  { countrySlug: 'czech-republic', label: 'Czech Republic', value: 'CzechRepublic' },
  { countrySlug: 'philippines', label: 'Philippines', value: 'Philippines' },
];

export const defaultSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'KC Overseas Education',
  url: 'https://www.studies-overseas.com/',
  logo: 'https://www.studies-overseas.com/kc_schema_logo.png',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '712 - 2222061',
    contactType: 'customer service',
    availableLanguage: 'en',
  },
  sameAs: [
    'https://www.facebook.com/KCOverseasEdu/',
    'https://twitter.com/KCOverseasEdu',
    'https://www.instagram.com/KCOverseasEdu/',
    'https://www.youtube.com/c/kcoverseasedu/',
    'https://www.linkedin.com/company/kcoverseasedu/',
    'https://www.snapchat.com/add/kcoverseasedu',
    'https://www.studiesabroadfranchisee.com/',
    'https://www.elanloans.com/',
  ],
};

export const commonJotformScript = [
  {
    jotformscript: `new JotformFeedback({
      formId: '${process.env.NEXT_PUBLIC_COMMON_JOTFORM_ID}',
      base: 'https://form.jotform.com/',
      windowTitle: 'Enquiry Form',
      background: '#FFA500',
      fontColor: '#FFFFFF',
      type: '0',
      height: 550,
      width: 570,
      openOnLoad: false
      });`,
  },
];

export const excludeChatScriptPaths = [
  'overseas-education-fair', 
  '/partners/study-abroad-recruiter', 
  'franchisee', 
  'recruiter', 
  'test-prep',
  'landing-page',
  'admissions-day',
  'applications-week',
  'webinar',
  'institution',
  'company',
  'virtual-admissions-day',
  'virtual-admissions-week',
  'branch',
  'online-counselling',
  'study-abroad-online-counselling',
  'thank-you'
];

export const INTEREST_TEXT = "I'm Interested in";
export const formatOrder = 'MMM dd, yyyy';

export const sliderSpeed = {
  desktopAutoplaySpeed: 4000,
  desktopSpeed: 1000,
  mobileAutoplaySpeed: 2000,
  mobileSpeed: 500,
};

export const CACHE_REVALIDATE = 21600;
export const CACHE_REVALIDATE_24H = 86400;

export const HIDE_WHATSAPP_BUTTON_PATHS = [
  "/admissions-day",
  "/applications-week",
  "/overseas-education-fair",
  "/webinar",
  "/virtual-admissions-week",
  "/virtual-admissions-day",
  "/branch",
  "/institution",
  "/company",
  "/study-abroad-online-counselling",
  "/partners",
  "/kc-overseas-mihan-nagpur",
  "/franchisee",
  "/partners/institutions-universities",
  "/partners/study-abroad-association",
  "/entrepreneur/franchise-proposal",
  "/landing-page",
  "/test-prep",
  "/online-counselling",
  "/recruiter",
  "/check-email"
];

export const HIDE_EXTERNAL_LINKS_PATHS = [
  "/check-email"
];

export const SHOW_CONTACT_WHITELIST = [
  "/contact-us/study-abroad-consultants-in-nagpur",
  "/contact-us/study-abroad-consultants-in-nagpur-sadar",
  "/contact-us/study-abroad-consultants-in-amravati",
  "/contact-us/study-abroad-consultants-in-sambhajinagar"
];

export const COUNTRY_DETAIL_SECONDARY_NAV_ITEMS = [  
  { id: 'why', title: "Overview", href: "", icon: "" },
  { id: 'universities', title: "Universities", href: "", icon: "" },
  { id: 'courses', title: "Courses", href: "", icon: "" },
  { id: 'cost', title: "Cost", href: "", icon: "" },
  { id: 'scholarships', title: "Scholarships", href: "", icon: "" },
  { id: 'intakes', title: "Intakes", href: "", icon: "" },
  { id: 'eligibility', title: "Eligibility", href: "", icon: "" },
  { id: 'exams', title: "Exams", href: "", icon: "" },
  { id: 'application', title: "Application", href: "", icon: "" },
  { id: 'visa', title: "Visas", href: "", icon: "" },
  { id: 'career', title: "Career", href: "", icon: "" },
  { id: 'cities', title: "Cities", href: "", icon: "" },
  { id: 'quick-reels', title: "Quick Reels", href: "", icon: "" },
  { id: 'top-admits', title: "Top Admits", href: "", icon: "" },
  { id: 'why-choose-kc', title: "Why Choose KC", href: "", icon: "" },
  { id: 'blogs', title: "Blogs", href: "", icon: "" },
  { id: 'faqs', title: "FAQs", href: "", icon: "" },
  { id: 'related-links', title: "Related Links", href: "", icon: "" },
]

interface EventContact {
  name: string;
  email: string;
  phone: string;
}
interface EventItem {
  id: string;
  thumbnailUrl: string;
  thumbnailAlt: string;
  category: string;
  title: string;
  paragraphs: string[];
  contact: EventContact;
}

export const EVENT_ITEMS: EventItem[] = [
  {
    id: "in-person-events",
    thumbnailUrl: "https://assets.studies-overseas.com/Group_224_73e3f53b56.png",
    thumbnailAlt: "University representatives attending an in-person B2B networking event",
    category: "— IN-PERSON EVENTS",
    title: "Partner Meets",
    paragraphs: [
      "As part of our continued commitment to enhancing student recruitment outcomes for our valued University Partners, KC Overseas regularly organizes exclusive B2B Study Abroad consultant partner networking events across key cities in India and select international locations.",
      "These events offer an excellent platform for University Representatives to engage directly with KC's leading Regional Study Abroad Partners, highlight the unique strengths and program offerings of their institution, and develop strategic collaborations aimed at driving quality student enrolments.",
      "The events are hosted with sponsorship support from participating universities.",
      "Universities interested in joining this initiative are encouraged to connect with:",
    ],
    contact: {
      name: "Mr. Sachin Bangale",
      email: "sbangale@kcoverseas.com",
      phone: "+91 83088 16813",
    },
  },
  {
    id: "virtual-events",
    thumbnailUrl: "https://assets.studies-overseas.com/Group_219_317669a054.png",
    thumbnailAlt: "University representative conducting an online B2B networking webinar",
    category: "— VIRTUAL EVENTS",
    title: "Webinars",
    paragraphs: [
      "KC Overseas regularly organizes exclusive online Webinars for partners — a dynamic platform for University Representatives to highlight the unique strengths and program offerings of their institution to KC's leading Study Abroad Partners across India and abroad.",
      "There is no participation fee for the participating universities.",
      "Universities interested in conducting the webinars are encouraged to connect with:",
    ],
    contact: {
      name: "Ms. Tejaswi Nair",
      email: "tnair@kcoverseas.com",
      phone: "+91 74200 22093",
    },
  },
];

export const TELEPHONE_NUMBERS = {
  headOffice: '+91 712 - 2222061/2222062'
};

export const HIDE_STUDENT_LOGIN = [
  '/partners/study-abroad-association',
  '/entrepreneur/franchise-proposal',
  '/partners/institutions-universities'
];


export const HEAD_OFFICE: HeadOffice = {
  badge: "Head Office",
  name: "KC MIHAN, Nagpur",
  address: "Plot No. 9C, MIHAN SEZ, Sector 17, MIHAN, Khapri, Nagpur, Maharashtra, India - 441108",
  callLines: ["+91 - 9890217999"],
  email: "zubin@kcoverseas.com",
  hours: "Monday to Saturday : 10:00 AM to 6:30 PM, Sunday : Closed",
  mapHref: "https://maps.app.goo.gl/Cxz1Qptz5JsgXJwV6",
  image: "/images/contcatus/mihan-head-office.png",
  mapImage: '/images/contcatus/mihan-head-office.png'
};

export const BRANCH_OFFICES: BranchOffice[] = [
  {
    id: "it-park",
    mapImage: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.7840525840857!2d79.0462168149342!3d21.121173885948433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x699518a8f68a1afa!2sKC%20Overseas%20Education%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1645081741260!5m2!1sen!2sin",
    name: "KC IT Park, Nagpur",
    address: "'Krishna', Plot No.10/2, I.T. Park, Opp. V.N.I.T, Behind Infotech Tower, Parsodi, Nagpur, Maharashtra, India - 440022",
    callLines: ["+91 - 8669602483", "+91 - 712 - 2222061/2222062"],
    email: "ningale@kcoverseas.com",
    hours: "Monday to Saturday : 10:00 AM to 6:30 PM, Sunday : Closed",
    mapHref: "https://maps.app.goo.gl/SSRC9B739RfDYKw4A",
  },
  {
    id: "sadar",
    mapImage: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.902150772015!2d79.07886331493482!3d21.15629198592944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x457479a0d9ee32a3!2sKC%20Overseas%20Education%20Sadar%20Nagpur!5e0!3m2!1sen!2sin!4v1645081714389!5m2!1sen!2sin",
    name: "KC Sadar, Nagpur",
    address: "2nd Floor, Block No. 112, Shriram Tower, Kingsway, Sadar, Nagpur, Maharashtra, India - 440001",
    callLines: ["+91 - 8669670625/", "+91 - 8669665180"],
    email: "vmokadam@kcoverseas.com",
    hours: "Monday to Saturday : 10:00 AM to 6:30 PM, Sunday : Closed",
    mapHref: "https://maps.app.goo.gl/GLPZWWhwh1xZzF319",
  },
];

export const COACHING_CATEGORY_ENUM: Record<string, string> = {
  "French Language": 'Frenchlanguage',
  "Japanese Language": 'Japaneselanguage',
  "German Language": 'Germanlanguage',
  "dMAT": 'dMat',
  "English Language": 'EnglishLanguage'
};
